import loadable from '@loadable/component';

export const SearchOrgRefinementsLoadable = loadable(
  () => import('./SearchOrgRefinements'),
  { resolveComponent: (module) => module.SearchOrgRefinements },
);
